<template>
  <div>
    <input
      class="w-100 mb-3 form-control"
      v-model="search"
      type="text"
      maxlength="191"
      @input="searchComputer"
      placeholder="Type a computer name"
    />
    <select
      class="custom-select"
      size="6"
      v-model="computer"
      style="
        min-height: 120px;
        padding: 0.5rem;
        border: 0px;
        background: #ffff;
        border: 1px solid #ccc;
      "
      :disabled="loading"
      @change="onChange"
    >
      <option v-for="(item, index) in options" :key="index" :value="item.value">
        {{ item.label }}
      </option>
    </select>

    <div class="users mt-2">
      <label for="">{{ t("username") }} <small style="font-size:9px">(Computer selection required first)</small> </label>
      <multiselect
        v-model="selectedUser"
        :options="users"
        :disabled="!computer"
        searchable="true"
        @change="onChangeUser"
      ></multiselect>
    </div>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import api from "@/api/index";
import { Roles } from "@/helpers/enums/Roles";
import { debounce } from "lodash";
import { useI18n } from "vue-i18n";
import Swal from "sweetalert2";

export default {
  setup() {
    const { t, locale } = useI18n();
    return { t, locale, Roles };
  },
  components: {
    Multiselect,
  },
  props: {
    group: {
      type: String,
      required: true,
    },
    currentSite: {
      type: String,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      value: null,
      computers: [],
      search: "",
      loading: false,
      users: [],
      selectedUser: "",
      computer: ""
    };
  },
  watch: {
    async group() {
      if (this.group) await this.getComputers();
      else this.value = null;
    },
  },
  computed: {
    options() {
      return Array.isArray(this.computers)
        ? this.computers.map((f) => {
            return {
              label: f.WindowsComputerName,
              value: f.ComputerId,
            };
          })
        : [];
    },
  },
  mounted() {
    this.getDefaultComputers();
  },
  methods: {
    searchComputer: debounce(async function (e) {
      this.loading = true;
      const res = await api.computers.searchComputer(
        e.target.value,
        this.currentSite,
        this.groups
      );
      const computerData = Array.isArray(res.data)
        ? res.data
        : res.data.entityData;
      this.computers = computerData.map((f) => {
        return {
          WindowsComputerName: f.windowsComputerName,
          ComputerId: f.computerId,
        };
      });
      this.loading = false;
    }, 1000),
    async getDefaultComputers() {
      const res = await api.computers.getAgscComputerList();
      this.computers = res.data;
    },
    async getComputers() {
      let guid = [this.group];
      if (Array.isArray(this.group)) {
        guid = this.group;
      }
      if (
        guid &&
        guid.length > 0 &&
        typeof guid[0] !== "object" &&
        guid[0] !== null
      ) {
        const res = await api.computers.getComputerByGroups(guid);
        if (res.data.statusCode != 200) {
          let msg = res.data.message;
          msg += "<br>";
          msg += res.data.errors.join("<br>");
          Swal.fire("Error", msg, "error");
        } else {
          this.computers = res.data.entityData;
        }
      }
    },
    onChangeUser(e) {
      this.$emit("userChange", e);
    },
    async onChange(event) {
      const computer = this.options.find((f) => f.value === event.target.value);
      const res = await api.computers.getComputerUserList(computer.value);
      if (res.data && res.data.entityData) {
        this.users = [];
        res.data.entityData.forEach((element) => {
          if (element) {
            this.users.push(element);
          }
        });
        this.selectedUser = "";
        console.log(this.users);
        this.$emit("computerChange", event);
      }
    },
    async created() {
      // let role = (
      //   this.$store.state.auth.user.find((f) => f.type == "role") || {}
      // ).value;
      // if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      //   role = Roles.AGMSAdmin;
      //   // role = Roles.SiteAudit;
      //   // role = Roles.GroupAdmin;
      //   // role = Roles.SiteAdmin;
      // }
      // if (role == Roles.GroupAdmin) {
      //   const groupGuid = (
      //     this.$store.state.auth.user.find((f) => f.type == "GroupGuid") || {}
      //   ).value;
      //   const guid = JSON.parse(groupGuid)[0];
      //   const res = await api.computers.getComputerByGroups(guid);
      //   if (res.data.statusCode != 200) {
      //     let msg = res.data.message;
      //     msg += "<br>";
      //     msg += res.data.errors.join("<br>");
      //     Swal.fire("Error", msg, "error");
      //   } else {
      //     this.computers = res.data.entityData;
      //   }
      // }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped></style>
